import React from 'react';
import InfoPR from './infoProduct';
import './style/main.css';

function MainProductPage() {
    return (
        <InfoPR></InfoPR>
    );
}
export default MainProductPage; 